import { CheckIcon, CrossIcon } from '@/assets/icons'
import { i18n } from '@/locale/i18n'
import { QUESTION_STATUS } from '@/constants/marketBackendEnums'
import QuestionService from '@/api/question'
import { getPositionLabels } from '@/features/market/utils/positionLabels'
 
/**
 * Get order status configuration based on outcome status
 * Returns null for active status (no badge needed)
 */
export const getOrderStatus = (outcome, question, parentQuestion) => {
  const q = question || parentQuestion
  if (!q || !outcome) return null

  const isOutcomeResolved =
    outcome.status === QUESTION_STATUS.RESOLVED ||
    (Boolean(outcome.resolution_display) &&
      (QuestionService.isResolved(q) || q.status === QUESTION_STATUS.RESOLVED))

  if (!outcome.status && !isOutcomeResolved) return null

  // Active status - no badge needed
  if (outcome.status === 'active' && !isOutcomeResolved) return null

  // Resolved status - show the resolution label (Yes/No, Up/Down, or custom)
  if (isOutcomeResolved) {
    if (!outcome.resolution_display) return null
    const labels = getPositionLabels(outcome, q)
    const isWinner =
      outcome.resolution_display === outcome.long_label ||
      outcome.resolution_display === labels.longLabel
    return {
      text: outcome.resolution_display,
      type: isWinner ? 'positive' : 'negative',
      icon: isWinner ? <CheckIcon width={13} height={13} /> : <CrossIcon width={10} height={10} />,
    }
  }

  // Cancelled status
  if (outcome.status === 'cancelled') {
    return {
      text: i18n('bet.cancelled'),
      type: 'warning',
    }
  }

  // Paused status
  if (outcome.status === 'paused') {
    return {
      text: i18n('bet.reviewing'),
      type: 'informative-1',
    }
  }

  // Stopped status
  if (outcome.status === 'stopped') {
    return {
      text: i18n('bet.closed'),
      type: 'negative',
    }
  }

  // Reversed status
  if (outcome.status === 'reversed') {
    return {
      text: i18n('bet.reversed'),
      type: 'warning',
    }
  }

  // Default fallback
  return {
    text: i18n('bet.closed'),
    type: 'negative',
  }
}

